import { Logo } from 'components/FollowSearchResultsNavigation/components/Logo';
import { FC, MutableRefObject } from 'react';
import { Box } from '@doda/io-react/common';
import styles from 'components/FollowSearchResultsNavigation/index.module.scss';
import classnames from 'classnames';
import { useOnScroll } from '../hooks/useOnScroll';

/**  WithoutNavigationコンポーネントのプロパティ */
interface Props {
  /** ログイン状態 */
  loginStatus: boolean;
  /** 総数を格納するHTMLエレメントの参照 */
  totalCount: MutableRefObject<HTMLElement | null>;
}

/**
 * WithoutNavigationコンポーネント
 *
 * @param {Props} props - コンポーネントのプロパティ
 * @param {boolean} props.loginStatus - ログイン状態を示すフラグ
 * @param {MutableRefObject<HTMLElement | null>} props.totalCount - 総数を格納するHTMLエレメントの参照
 * @returns {JSX.Element} - WithoutNavigationコンポーネント
 */
export const WithoutNavigation: FC<Props> = ({ loginStatus, totalCount }) => {
  const { scrolled: isShowHeader } = useOnScroll(100);

  return (
    <Box
      className={classnames(styles.followSearchResultsNavigation, {
        [styles.is_show]: isShowHeader,
      })}
      color="white"
      boxShadow="blue"
    >
      <div className={styles.followSearchResultsNavigation__inner}>
        <Logo loginStatus={loginStatus} />
        <p className={styles.followSearchResultsNavigation__jobCount}>
          この条件の求人数
          <span ref={totalCount} />件
        </p>
      </div>
    </Box>
  );
};
